
import { defineComponent, onActivated, onDeactivated, reactive, ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { get_customer_detail } from '@/api/mjstore-model';
import { useStore } from 'vuex';
import {
  btn_record,
  btn_record2,
  btn_record3,
  btn_record4,
  btn_record5,
  btn_record6,
} from '@/views/profile/basic/basic.ts';
import PageModel2 from '@/components/page-model2/index.vue';
import bus from '@/utils/bus';
import { isNumber } from 'lodash';
import modalBox from '@/components/form-modal/modal-tools';

export default defineComponent({
  setup() {
    const route = useRoute();
    const store = useStore();
    const event_bus = bus;
    const state = reactive({
      isReloadPage: false,
    });
    const customer_id = ref<number>(Number(route.params['id']));
    const activeKey = ref<string>('基础档案');
    route.meta.title = route.params['name'];
    const current_org = store.getters['user/current_org'];
    const search = reactive({
      current: 1,
      pageSize: 10,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        org_id: current_org.id,
        is_active: true,
        is_now_num: true,
        customer_id: Number(route.params['id']),
      },
    });
    const dataList: any = reactive({
      full_name: '',
    });

    onMounted(() => {
      setTimeout(() => {
        const myDoc = document.getElementsByClassName('my ')[0];
        (myDoc.getElementsByClassName('ant-tabs-tab ') as any).forEach(
          (item: any, index: number) => {
            if (index < 4) {
              item.style.backgroundColor = '';
              item.style.co = '';
            } else if (index < 9) {
              item.style.backgroundColor = '#1DA57A';
              item.style.color = '#FFF';
            } else if (index < 10) {
              item.style.backgroundColor = '#CFCFCF';
              item.style.color = '#FFF';
            }
          },
        );
      }, 1);
    });

    const refresh_customer_info = () => {
      get_customer_detail({
        org_id: current_org.id,
        customer_id: customer_id.value,
      }).then((res: any) => {
        Object.assign(dataList, res.customer);
        Object.assign(dataList, res.customer_wallet);
      });
    };
    const refresh_active_page = () => {
      state.isReloadPage = true;
    };
    const local_path = route.path;
    refresh_customer_info();
    watch(
      () => route.path,
      () => {
        if (route.path == local_path && !route.query.q) {
          refresh_customer_info();
        }
      },
    );

    const tableList = ref([
      {
        title: '基础档案',
        search: { ...search, requestParams: { ...search.requestParams } },
        modalType: 'mjstore-baseinfo',
        closable: false,
      },
      {
        title: '诉求及解决方案',
        search: { ...search, requestParams: { ...search.requestParams } },
        modalType: 'mjstore-requireinfo',
        closable: false,
      },
      // {
      //   title: '计划',
      //   search: search,
      //   modalType: 'mjstore-planinfo',
      //   closable: false,
      // },
      // {
      //   title: '回访',
      //   search: search,
      //   modalType: 'mjstore-feedbackinfo',
      //   closable: false,
      // },
      {
        title: '服务过程',
        search: { ...search, requestParams: { ...search.requestParams } },
        modalType: 'mjstore-servicedetail',
        closable: false,
      },
      {
        title: '售后产品跟进',
        search: { ...search, requestParams: { ...search.requestParams } },
        modalType: 'mjstore-postsale',
        closable: false,
      },
      {
        title: '充值记录',
        search: { ...search, requestParams: { ...search.requestParams } },
        modalType: 'mjstore-czrecord',
        closable: false,
      },
      {
        title: '待执行订单',
        search: { ...search, requestParams: { ...search.requestParams } },
        modalType: 'mjstore-orderrecord',
        closable: false,
      },
      {
        title: '待执行卡项',
        search: { ...search, requestParams: { ...search.requestParams } },
        modalType: 'mjstore-cardrecord',
        closable: false,
      },
      {
        title: '套餐明细',
        search: { ...search, requestParams: { ...search.requestParams, is_delete: false } },
        modalType: 'mjstore-setrecord',
        closable: false,
      },
      {
        title: '耗单明细',
        search: { ...search, requestParams: { ...search.requestParams, is_delete: false } },
        modalType: 'mjstore-orderusedrecord',
        closable: false,
      },
      {
        title: '撤单记录',
        search: { ...search, requestParams: { ...search.requestParams, is_delete: false } },
        modalType: 'mjstore-orderremove',
        closable: false,
      },
      {
        title: '撤卡记录',
        search: { ...search, requestParams: { ...search.requestParams, is_delete: false } },
        modalType: 'mjstore-cardremove',
        closable: false,
      },
    ]);
    const selectKey = (data: any) => {
      let arr: any = tableList.value.filter(item => {
        return item.title == data.title + ':' + data.data.code;
      });
      if (arr.length < 1) {
        let refresh_setrecord = { ...search };
        Object.assign(refresh_setrecord.requestParams, {
          require_info_id: data.data.id,
          code: data.data.code,
        });
        tableList.value.splice(2, 0, {
          title: data.title + ':' + data.data.code,
          search: { ...refresh_setrecord, requestParams: { ...refresh_setrecord.requestParams } },
          modalType: data.type,
          closable: true,
        });
      }
      activeKey.value = data.title + ':' + data.data.code;
    };
    const event_bus_refresh_custom_info = (tmp_customer_id: any) => {
      if (tmp_customer_id == customer_id.value) {
        refresh_customer_info();
      }
    };
    const event_bus_selectKey = (data: any) => {
      selectKey(data);
    };

    event_bus?.on('refresh_custom_info', event_bus_refresh_custom_info);
    event_bus?.on('refresh_planinfo', event_bus_selectKey);
    event_bus?.on('refresh_feedbackinfo', event_bus_selectKey);
    event_bus?.on('refresh_orderrecord', event_bus_selectKey);
    event_bus?.on('refresh_cardrecord', event_bus_selectKey);
    event_bus?.on('refresh_setrecord', event_bus_selectKey);

    onActivated(() => {
      event_bus?.off('refresh_custom_info', event_bus_refresh_custom_info);
      event_bus?.off('refresh_planinfo', event_bus_selectKey);
      event_bus?.off('refresh_feedbackinfo', event_bus_selectKey);
      event_bus?.off('refresh_orderrecord', event_bus_selectKey);
      event_bus?.off('refresh_cardrecord', event_bus_selectKey);
      event_bus?.off('refresh_setrecord', event_bus_selectKey);
      // 先解监听，再监听，防止重复
      event_bus?.on('refresh_custom_info', event_bus_refresh_custom_info);
      event_bus?.on('refresh_planinfo', event_bus_selectKey);
      event_bus?.on('refresh_feedbackinfo', event_bus_selectKey);
      event_bus?.on('refresh_orderrecord', event_bus_selectKey);
      event_bus?.on('refresh_cardrecord', event_bus_selectKey);
      event_bus?.on('refresh_setrecord', event_bus_selectKey);
    });
    onDeactivated(() => {
      event_bus?.off('refresh_custom_info', event_bus_refresh_custom_info);
      event_bus?.off('refresh_planinfo', event_bus_selectKey);
      event_bus?.off('refresh_feedbackinfo', event_bus_selectKey);
      event_bus?.off('refresh_orderrecord', event_bus_selectKey);
      event_bus?.off('refresh_cardrecord', event_bus_selectKey);
      event_bus?.off('refresh_setrecord', event_bus_selectKey);
    });

    const onEdit = (targetKey: string | MouseEvent, action: string) => {
      if (action === 'add') {
        console.log(action);
      } else {
        remove(targetKey as string);
      }
    };
    const remove = (targetKey: string) => {
      let lastIndex = 0;
      tableList.value.forEach((pane, i) => {
        if (pane.title === targetKey) {
          lastIndex = i - 1;
        }
      });
      tableList.value = tableList.value.filter(pane => pane.title !== targetKey);
      if (tableList.value.length && activeKey.value === targetKey) {
        if (lastIndex >= 0) {
          activeKey.value = tableList.value[lastIndex].title;
        } else {
          activeKey.value = tableList.value[0].title;
        }
      }
    };
    const handleCZ = () => {
      const result: any = btn_record.cb(customer_id.value);
      if (result instanceof Promise) {
        result.then(() => {
          refresh_customer_info();
          refresh_active_page();
        });
      }
    };
    const handleXTC = () => {
      const result: any = btn_record2.cb({ customer_id: Number(route.params['id']) });
      if (result instanceof Promise) {
        result.then(() => {
          refresh_customer_info();
        });
      }
    };
    const handleXD = () => {
      btn_record3.cb({ customer_id: Number(route.params['id']) });
    };
    const handleGK = () => {
      btn_record4.cb({ customer_id: Number(route.params['id']) });
    };
    const handleTX = () => {
      const result: any = btn_record5.cb({ customer_id: Number(route.params['id']) });
      if (result instanceof Promise) {
        result.then(() => {
          refresh_customer_info();
        });
      }
    };
    const handlePrint = () => {
      const result: any = btn_record6.cb({ customer_id: Number(route.params['id']) });
      if (result instanceof Promise) {
        result.then(() => {
          refresh_customer_info();
        });
      }
    };
    const get_tofixed = (num: any) => {
      if (isNumber(num)) {
        if (Number(num.toFixed(0)) == 0) {
          return 0;
        } else {
          return num.toFixed(0);
        }
      } else {
        return '';
      }
    };
    const search1 = reactive({
      current: 1,
      pageSize: 1000,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        org_id: current_org.id,
        is_active: true,
      },
    });
    const look_momeny = () => {
      const editModal = reactive({
        visible: true,
        component: 'TablePageModal2',
        obj: {
          title: '充值余额明细',
          search: {
            ...search1,
            requestParams: { ...search1.requestParams, customer_id: Number(route.params['id']) },
          },
          modalType: 'mjstore-money',
        },
      });
      modalBox(editModal);
    };
    return {
      state,
      onEdit,
      tableList,
      route,
      activeKey,
      dataList,
      handleCZ,
      handleXD,
      handleXTC,
      handleGK,
      handleTX,
      handlePrint,
      get_tofixed,
      look_momeny,
      customer_id,
    };
  },
  components: {
    PageModel2,
  },
});
